module.exports = __webpack_public_path__ + "img/about-memory.80c9f7e1.jpg";